import { render, staticRenderFns } from "./ZalogaItems.vue?vue&type=template&id=07ae0ef8&"
import script from "./ZalogaItems.vue?vue&type=script&lang=js&"
export * from "./ZalogaItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports